import { Box } from "@mui/material";
import { FC, PropsWithChildren } from "react";

export const ConfigSidebarMinWidth = 320;

const ConfigTabPaper: FC<PropsWithChildren> = (props) => {
  return (
    <Box
      key={"ConfigBackdrop"}
      sx={{
        width: "100%",
        p: 1,
        minHeight: 0,
        overflowY: "auto",
      }}
    >
      {props.children}
    </Box>
  );
};

export { ConfigTabPaper };
